module.exports = __webpack_public_path__ + "img/car_00011.5c453352.jpg";